import { customSanitize } from "@/utils/customSanitize";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import React from "react";
export const ContentTag = ({
  content,
  extraClass = "",
  showTitle = false,
}: {
  content: string;
  extraClass?: string;
  showTitle?: boolean;
}) => {
  const { getLabel } = useGlobalContext();
  const sanitized = customSanitize(content);
  const hasPTag = (html: string) => /<p\b[^>]*>/i.test(html);
  const hasBlockLevel = (html: string) =>
    /<(address|article|aside|blockquote|canvas|div|dl|fieldset|figcaption|figure|footer|form|h[1-6]|header|hr|li|main|nav|noscript|ol|p|pre|section|table|tbody|td|tfoot|th|thead|tr|ul)\b/i.test(
      html,
    );
  const shouldUseDiv = hasPTag(sanitized) || hasBlockLevel(sanitized);

  return (
    <>
      {showTitle && (
        <span className="title-media-info">
          {getLabel("cooking_mode_info_image_title", "Beschreibung")}
        </span>
      )}

      {shouldUseDiv ? (
        <div
          className={`${extraClass}`}
          dangerouslySetInnerHTML={{ __html: sanitized }}
        />
      ) : (
        <p
          className={extraClass.replace("inherit-parent", "")}
          dangerouslySetInnerHTML={{ __html: sanitized }}
        />
      )}
    </>
  );
};
